var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0726 2.06131C36.7548 2.07691 36.4627 2.24095 36.2811 2.50237L12.5603 36.5315C12.0834 37.2152 12.5726 38.153 13.4062 38.153H29.8176L27.8478 62.8244C27.7707 63.8673 29.1159 64.3495 29.7189 63.4951L53.4397 29.4679C53.9161 28.7849 53.4284 27.8481 52.5958 27.8465H36.1824L38.1542 3.17311C38.2037 2.55182 37.695 2.02861 37.0726 2.06131Z",
    fill: "#CCCCCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash2);
export default __webpack_public_path__ + "static/media/flash2.b1d83035d0b98f49130f2bfe6cf43d79.svg";
export { ForwardRef as ReactComponent };